import Colors from '@constants/Colors';
import { Search01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react-native';
import DosAndDonts from '@molecules/DosAndDonts';
import TopicCard from '@molecules/TopicCard';
import ScheduleCalendar from '@organisms/ScheduleCalendar';
import { useGetProfile } from '@sunrise-ui/api-client';
import { withAuthGate } from '@sunrise-ui/composites';
import {
  Button,
  ButtonVariants,
  TextInput,
  TextReg,
  useAuthStore,
  useDynamicStyles,
  type WithResponsive,
} from '@sunrise-ui/primitives';
import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';

const dos = ['Summarize', 'Be specific', 'Check spelling and grammar'];

const donts = [
  'Include your name',
  'Include links',
  'Write anything inappropriate',
];
function SuggestView() {
  const styles = useDynamicStyles(createStyles);
  const [topic, setTopic] = useState('');
  const [step, setStep] = useState(1);
  const { currentUserId } = useAuthStore();
  const { isLoading: isLoadingProfile, data: profile } =
    useGetProfile(currentUserId);

  return (
    <View style={styles.container}>
      {step === 1 && (
        <>
          <TextInput
            label="Suggest a topic..."
            value={topic}
            onChange={(text) => {
              setTopic(text);
            }}
            icon={
              <HugeiconsIcon icon={Search01Icon} color={Colors.dark.text} />
            }
            style={styles.suggestTopic}
          />
          <Button
            onPress={() => {
              setStep(2);
            }}
            variant={ButtonVariants.PURPLE}
            style={styles.nextButton}
            disabled={!topic}
          >
            Next
          </Button>
          <View style={styles.suggestionSection}>
            <TopicCard topic="Tanstack’s useInfiniteQuery hook in React Native" />
            <DosAndDonts dos={dos} donts={donts} />
          </View>
        </>
      )}
      {step === 2 && !isLoadingProfile && (
        <>
          <TopicCard
            topic={topic}
            onEdit={() => {
              setStep(1);
            }}
            name={`${profile?.first_name} ${profile?.last_name}`}
          />
          <TextReg>
            When do you have 30m this week to connect with others on this topic?
          </TextReg>
          <ScheduleCalendar />
        </>
      )}
    </View>
  );
}

const createStyles = ({ isMobile, isTablet }: WithResponsive) =>
  StyleSheet.create({
    container: {
      flex: 1,
      margin: isMobile ? 12 : isTablet ? 16 : 20,
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: 30,
      display: 'flex',
    },
    nextButton: {
      width: 140,
    },
    suggestTopic: {
      width: isMobile ? '100%' : isTablet ? '75%' : '50%',
    },
    suggestionSection: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 30,
    },
  });

export default withAuthGate(SuggestView);
